import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';
import { ProcessingState } from '@services/core-services/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-chart-loader-wrapper',
  imports: [CommonModule],
  templateUrl: './analytics-loading-wrapper.component.html',
  styleUrls: ['./analytics-loading-wrapper.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartLoaderWrapperComponent {
  @Input() loadingState$!: Observable<ProcessingState>;
  @Input() errorMessage: string = '';
  @Input() emptyMessage: string = '';
  @Input() loaderImagePath: string = '/assets/loader-spin.svg';
  @Input() headingTitle: string = '';
  @Input() subtitle: string = '';
  @ContentChild(TemplateRef) contentTemplate!: TemplateRef<any>;

  protected processingState = ProcessingState;
}
